import { ArrowRight } from 'lucide-react';
import { projects } from '@/data/projects';
import { ZoomableImage } from '@/components/common/ImageLightbox';
import { MotionReveal } from '@/components/common/MotionReveal';

export function ProjectsSection() {
  const [featured, ...secondary] = projects;

  return (
    <section
      id="projekti"
      className="scroll-mt-20 bg-footer py-20 text-footer-text sm:py-26 lg:py-32"
    >
      <div className="site-container">
        <div className="grid gap-5 lg:grid-cols-[0.78fr_0.5fr] lg:items-end lg:justify-between lg:gap-24">
          <div>
            <p className="text-sm font-medium text-footer-muted">
              Odabrani radovi
            </p>
            <h2 className="mt-3 max-w-3xl text-balance text-4xl font-semibold leading-[1.08] tracking-[-0.05em] text-footer-text sm:text-5xl lg:text-[3.6rem]">
              Projekti se najbolje objašnjavaju rezultatom.
            </h2>
          </div>
          <p className="max-w-lg text-base leading-7 text-footer-muted">
            Tri tipična angažmana: operativno planiranje, uređenje internog rada
            i koordinacija izlaska nove usluge na tržište.
          </p>
        </div>

        <MotionReveal className="mt-11 grid lg:mt-16 lg:grid-cols-12 lg:items-stretch">
          <figure className="overflow-hidden lg:col-span-9 lg:col-start-1 lg:row-start-1">
            <ZoomableImage
              wrapperClassName="h-full"
              className="aspect-[16/10] h-full min-h-[440px] w-full object-cover lg:aspect-[16/9]"
              src={featured.image}
              alt={featured.imageAlt}
              loading="lazy"
            />
          </figure>
          <article className="relative z-10 bg-surface p-6 text-text-primary sm:p-8 lg:col-span-4 lg:col-start-9 lg:row-start-1 lg:my-14 lg:p-9 lg:shadow-[0_14px_34px_rgba(0,0,0,0.18)]">
            <p className="section-label">{featured.category}</p>
            <h3 className="mt-3 text-2xl font-semibold tracking-[-0.03em] text-text-primary sm:text-3xl">
              {featured.title}
            </h3>
            <p className="mt-4 text-sm leading-6 text-text-secondary sm:text-base">
              {featured.description}
            </p>
            <a
              className="animated-link group mt-9 inline-flex items-center gap-2 text-sm font-semibold text-text-primary transition-colors hover:text-primary"
              href="/kontakt"
            >
              Razgovarajte sa nama
              <ArrowRight
                aria-hidden="true"
                className="size-4 transition-transform duration-200 group-hover:translate-x-1"
              />
            </a>
          </article>
        </MotionReveal>

        <div className="mt-12 grid gap-10 md:grid-cols-12 lg:mt-16">
          {secondary.map((project, index) => (
            <MotionReveal
              key={project.id}
              delay={index * 0.06}
              className={
                index === 0 ? 'md:col-span-7' : 'md:col-span-5 md:pt-18'
              }
            >
              <article>
                <ZoomableImage
                  className={`w-full rounded-[var(--radius-sm)] object-cover ${index === 0 ? 'aspect-[16/9]' : 'aspect-[4/3]'}`}
                  src={project.image}
                  alt={project.imageAlt}
                  loading="lazy"
                />
                <div className="mt-4 grid gap-2 sm:grid-cols-[0.45fr_0.55fr] sm:gap-5">
                  <div>
                    <p className="text-xs text-footer-muted">
                      {project.category}
                    </p>
                    <h3 className="mt-1 text-lg font-semibold tracking-[-0.02em] text-footer-text">
                      {project.title}
                    </h3>
                  </div>
                  <p className="text-sm leading-6 text-footer-muted">
                    {project.description}
                  </p>
                </div>
              </article>
            </MotionReveal>
          ))}
        </div>
      </div>
    </section>
  );
}
